// eslint-disable-next-line import/prefer-default-export
export function convertStringToMultilineParagraphs(value: string) {
  if (!value) return [];
  const splitted = value.split('\n');
  // eslint-disable-next-line react/no-array-index-key
  return splitted.map((v, index) => (<p key={index} style={{ overflowWrap: 'break-word' }}>{v}&nbsp;</p>));
}
